import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../contexts/AuthContext";
import "../App.css";

const OIDCCallback = () => {
  const { handleCallback } = useAuth();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [error, setError] = useState(null);
  const hasProcessed = useRef(false);

  useEffect(() => {
    const processCallback = async () => {
      // Prevent multiple executions
      if (hasProcessed.current) {
        return;
      }

      hasProcessed.current = true;

      try {
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");
        const state = urlParams.get("state");

        if (!code) {
          throw new Error("No authorization code received");
        }

        // Handle the callback with retry logic
        await handleCallback(code, state);
        setStatus("success");

        // Redirect to main app after a short delay
        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
      } catch (err) {
        console.error("Callback processing error:", err);

        // Check for specific error types and provide helpful messages
        if (err.message.includes("role") || err.message.includes("403")) {
          setError(
            "Acesso Negado: Não tem as permissões necessárias. Por favor, contacte o administrador para atribuir o papel apropriado."
          );
        } else if (
          err.message.includes("500") ||
          err.response?.status === 500
        ) {
          setError(
            "Erro do Servidor: Houve um problema com o servidor de autenticação. Por favor, tente novamente em alguns momentos."
          );
        } else if (err.message.includes("No authorization code")) {
          setError(
            "Erro de Autenticação: Nenhum código de autorização foi recebido. Por favor, tente fazer login novamente."
          );
        } else if (err.message.includes("Failed to complete login")) {
          setError(
            "Login Falhado: Não foi possível completar o processo de autenticação. Por favor, tente novamente."
          );
        } else {
          setError(err.message);
        }

        setStatus("error");
      }
    };

    processCallback();
  }, [handleCallback]);

  if (status === "loading") {
    return (
      <div className="callback-page">
        <div className="callback-card">
          <div className="callback-spinner"></div>
          <p className="callback-title">A processar login...</p>
          <p className="callback-desc">Por favor, aguarde um momento.</p>
        </div>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div className="callback-page">
        <div className="callback-card">
          <div className="callback-status-icon callback-status-success">✓</div>
          <p className="callback-title">Login bem-sucedido!</p>
          <p className="callback-desc">A redirecionar...</p>
        </div>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="callback-page">
        <div className="callback-card">
          <div className="callback-status-icon callback-status-error">✕</div>
          <p className="callback-title">Login Falhado</p>
          <p className="callback-desc">{error || "Ocorreu um erro durante o login."}</p>
          <button
            onClick={() => (window.location.href = "/")}
            className="sso-button"
          >
            <span className="sso-button-inner">Tentar Novamente</span>
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default OIDCCallback;
